import React, { useState, useEffect } from "react";
import "./ProjectDetailHeader.scss";
import { Link } from "react-router-dom";
import { uniqWith, isEqual, sortBy } from "lodash";
import { withFirebase } from "components/Firebase";

import Button from "components/Button";

const alphaUniqSort = array => {
  return sortBy(uniqWith([...array], isEqual), [skill => skill.label]);
};

const HeartButton = ({ project, firebase }) => {
  // Hooks for heart state
  const [likeCount, incrementLikes] = useState(0);

  useEffect(() => {
    if (project.likes) incrementLikes(project.likes);
  }, [project.likes]);

  const addLike = () => {
    firebase.heartProject(project.id, likeCount);
    incrementLikes(likeCount + 1);
  };

  return (
    <Button onClick={addLike} type="primary" data-icon-count="true">
      <i className="ion ion-md-heart" />
      <span className="count">{likeCount}</span>
    </Button>
  );
};

const WrappedHeartComponent = withFirebase(HeartButton);

const ProjectDetailHeader = ({ user, project, isProjectOwner }) => {
  const skills = alphaUniqSort(project.tags.skills.concat(project.tags.other));

  return (
    <div className="ProjectDetailHeader">
      <div className="head">
        <div className="info">
          <h2>{project.basicInformation.title}</h2>
          <span>
            by{" "}
            <Link to={`/u/${user.userName}`}>
              {user.firstName} {user.lastName}
            </Link>
          </span>
        </div>
        <div className="buttons">
          {isProjectOwner && (
            <Button to={`/edit-project/${project.id}`} type="primary">
              Edit Project
            </Button>
          )}
          <WrappedHeartComponent project={project} />
        </div>
      </div>
      {skills && (
        <div className="tags">
          <ul>
            {skills.map((skill, i) => (
              <li key={i}>{skill.label}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProjectDetailHeader;
